import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import styled from 'styled-components'

import { ItemHeader } from '@/components/Style/Common'
import type { Address } from '@/types/Activity'

const IncomeDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 10px;
`

const SmallIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 5px;
`

interface Props {
  institution: string
  address: Address
  idNumber: string
  startDate: string
  endDate: string
  status?: string
}

const StudentIncomeDetails: React.FC<Props> = ({
  institution,
  address,
  idNumber,
  startDate,
  endDate,
  status,
}) => (
  <div>
    <IncomeDetails>
      <div>
        {institution && (
          <>
            <ItemHeader>Institution Name</ItemHeader>
            <p>{institution}</p>
          </>
        )}
        {idNumber && (
          <>
            <ItemHeader>Student ID Number</ItemHeader>
            <p>{idNumber}</p>
          </>
        )}
      </div>
      {address && (
        <div>
          <ItemHeader>Instituion Address</ItemHeader>
          <p>{address.line1}</p>
          <p>{address.city}</p>
          <p>{address.postcode}</p>
          <p>{address.country}</p>
        </div>
      )}
    </IncomeDetails>
    {status !== 'Finance' && (
      <IncomeDetails>
        <div>
          <ItemHeader>Payments Started</ItemHeader>
          <div className="side-by-side-flex-start">
            {' '}
            <SmallIcon src="/assets/svg/calendar.svg" alt="" />{' '}
            <p> {moment.utc(startDate).format('LL')}</p>
          </div>
        </div>

        {endDate && (
          <div>
            <ItemHeader>Payments are due to end</ItemHeader>
            <div className="side-by-side-flex-start">
              {' '}
              <SmallIcon src="/assets/svg/calendar.svg" alt="" />{' '}
              <p> {moment.utc(endDate).format('LL')}</p>
            </div>
          </div>
        )}
      </IncomeDetails>
    )}
  </div>
)

export default StudentIncomeDetails
